

export function redirect(url: string, navigate: Function, redirect?: boolean) {

    let a = document.createElement('a');
    a.setAttribute('href', url);
    if(redirect){
        a.setAttribute('target', '_blank');
        a.click();
    } else {
        navigate(url);
    }
    
}

export const currencyFormat = (num: number) => {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " XAF"
 }